module.exports = __webpack_public_path__ + "img/zgjzkxyjy.3bdd8e6d.png";